// import reportCsList from '../components/reportCs/reportCsList.vue'
// import addReportCs from '../components/reportCs/addReportCs.vue'
// import viewReportCs from '../components/reportCs/viewReportCs.vue'

export default [
    {
        path: 'reportCs/reportCsList',
        component: resolve => require(['@/components/reportCs/reportCsList'],resolve),
        name:"ReportCsList",
        meta:{
            id:'641',
            node:'reportCs',
            url:'reportCsList',
        }
    },
    {
        path: 'reportCs/addReportCs',
        component: resolve => require(['@/components/reportCs/addReportCs'],resolve),
        name:"AddReportCs",
        meta:{
            // id:'641',
            node:'reportCs',
            url:'addReportCs',
        }
    },
    {
        path: 'reportCs/viewReportCs',
        component: resolve => require(['@/components/reportCs/viewReportCs'],resolve),
        name:"ViewReportCs",
        meta:{
            // id:'641',
            node:'reportCs',
            url:'viewReportCs',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/reportCs.js